export const TX_TYPES = {
  'DISBURSEMENT': 'DESEMBOLSO',
  'PAYMENT': 'PAGO',
  'APPROVED':'APROBADO',
  'PENDING':'PENDIENTE',
  'PAID':'PAGADA',
  'COMPLETED':'CANCELADO',
  'ACTIVE':'VIGENTE',
  'INTEREST_PAYMENT': 'PAGO DE INTERÉS',
  'FEE_PAYMENT': 'PAGO DE CUOTA',
  'ADJUSTMENT': 'AJUSTE',
  'LATE_FEE': 'MORA',
  'MARRIED': 'CASADO',
  'URBAN': 'URBANA',
  'OWNED':'PROPIA',
  'FAMILY OWNED':'BIEN DE FAMILIA',
  'FINANCED':'FINANCIADA',
  'RENTED':'ALQUILADA',
  'SINGLE':'SOLTERO',
  'ACTIVE':'ACTIVO',
  '1':'DIARIO',
  '2':'SEMANAL',
  '3':'QUINCENAL',
  '4':'MENSUAL',

};

/**
 * Traduce un tipo de transacción o devuelve el original si no existe mapeo
 */
export const translateTxType = (type) => {
  return TX_TYPES[type] || type;
};